import { render } from "./ChinaGold.vue?vue&type=template&id=9d407d82&scoped=true"
import script from "./ChinaGold.vue?vue&type=script&lang=js"
export * from "./ChinaGold.vue?vue&type=script&lang=js"

import "./ChinaGold.vue?vue&type=style&index=0&id=9d407d82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d407d82"]])

export default __exports__